import { axiosInstance } from "@src/shared/api";
import { LIGIN_API_URL } from "../constants";
import { LoginResponseDto } from "../interfaces/loginResponseDto";

export interface GetYandexAutorizationUserDto {
  exchange_code: string;
}

export const getYandexAutorizationUser = (data: GetYandexAutorizationUserDto) =>
  axiosInstance.post<LoginResponseDto>(
    LIGIN_API_URL.getYandexAutorizationUser(),
    data
  );
